import { ImpactModule } from 'types'
import { SOCIAL_MANAGER_PAGES } from './pages'
import { SOCIAL_MANAGER_PAGES_ORDER_FOR_PERMISSIONS } from './pagesOrderForPermissions'

export const SOCIAL_MANAGER_MODULE: ImpactModule = {
  NAME: 'admin',
  NAME_PTBR: 'Gestão Social',
  UPPER_NAME: 'ADMIN',
  API_NAME: 'ADMIN',
  PAGES: SOCIAL_MANAGER_PAGES,
  PAGES_ORDER_FOR_PERMISSIONS: SOCIAL_MANAGER_PAGES_ORDER_FOR_PERMISSIONS,
}
